oyc.IconList = {
  container: '.icon-list-list',
  item: '.icon-list-list details',
  attribute: 'open',
  isDesktopMode: null,

  init: function () {
    this.container = $(this.container);
    if (this.container.length > 0) {

      oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Css/fontawesome.css');

      this.toggleEvents();

      $(window).on('resize', this.debounce(() => {
        this.toggleEvents();
      }, 250));
    }
  },

  toggleEvents: function () {
    const isDesktop = window.innerWidth >= 1024;
    if (this.isDesktopMode === isDesktop) {
      return;
    }
    this.isDesktopMode = isDesktop;

    if (isDesktop) {
      // Replace 'name' with 'data-name'
      $(this.item).each(function () {
        const name = $(this).attr('name');
        if (name) {
          $(this).attr('data-name', name).removeAttr('name');
        }
        // Replace <details> with <div class="details">
        const $div = $('<div class="details"></div>');
        $div.html($(this).html());
        $(this).replaceWith($div);
      });
      $(this.item).attr(this.attribute, true);

      $(this.item).on('click.prevent', 'summary', function (e) {
        e.preventDefault();
      });
    } else {
      // Restore 'name' from 'data-name'
      $(this.item).each(function () {
        const dataName = $(this).attr('data-name');
        if (dataName) {
          $(this).attr('name', dataName).removeAttr('data-name');
        }
      });
      // Replace <div class="details"> back with <details>
      this.container.find('div.details').each(function () {
        const $details = $('<details></details>');
        $details.html($(this).html());
        $(this).replaceWith($details);
      });

      $(this.item).off('click.prevent');
      $(this.item).removeAttr(this.attribute);
    }
  },

  debounce: function (func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }
};
